<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M124 1216 c-17 -13 -19 -30 -22 -187 -2 -96 -1 -188 3 -206 11 -62
14 -63 251 -63 240 0 222 7 203 -80 -13 -60 -60 -120 -93 -120 -13 0 -31 9
-41 20 -16 17 -31 20 -110 20 -137 0 -129 13 -133 -235 -4 -268 -9 -258 131
-252 56 3 116 8 133 12 26 6 37 2 65 -23 57 -49 69 -52 214 -52 l137 0 30 30
c23 24 29 37 26 60 -3 17 -1 30 4 30 5 0 16 15 25 34 12 27 13 40 5 64 -9 26
-7 33 10 49 17 15 19 27 16 71 -3 29 -1 55 4 58 4 3 8 23 8 44 0 60 -22 70
-157 70 l-112 0 7 33 c4 17 7 63 7 100 l0 68 35 -3 c31 -3 35 -7 47 -48 26
-88 54 -89 123 -5 l45 55 77 0 c119 0 121 5 116 269 -3 157 -5 174 -22 187
-29 21 -1003 21 -1032 0z m1010 -42 c8 -20 8 -338 0 -358 -5 -13 -22 -16 -82
-16 l-76 0 -51 -55 c-29 -30 -54 -55 -57 -55 -3 0 -11 20 -17 45 -13 50 -32
65 -86 65 -28 0 -42 6 -57 25 -14 18 -29 25 -54 25 -24 0 -43 -8 -60 -25 l-25
-25 -208 0 c-181 0 -210 2 -215 16 -8 20 -8 338 0 358 5 14 58 16 494 16 436
0 489 -2 494 -16z m-447 -384 c15 -30 17 -151 3 -199 -18 -63 -6 -70 133 -73
116 -3 122 -4 125 -24 2 -12 -5 -29 -14 -39 -14 -14 -15 -21 -6 -36 21 -34 15
-78 -13 -91 -30 -13 -30 -17 -8 -56 20 -34 13 -59 -22 -72 -25 -10 -33 -34
-15 -45 17 -10 11 -44 -9 -55 -11 -5 -77 -10 -148 -10 l-128 0 -49 40 c-26 22
-59 40 -72 40 l-24 0 0 174 0 173 39 7 c75 12 113 73 130 212 8 65 21 87 51
81 8 -1 20 -13 27 -27z m-287 -435 l0 -206 -87 3 -88 3 -3 190 c-1 104 0 195
2 202 4 9 31 13 91 13 l85 0 0 -205z"
      />
      <path
        d="M302 1123 c-5 -10 -12 -30 -16 -45 -6 -26 -10 -28 -56 -28 -61 0 -66
-17 -15 -51 27 -18 34 -29 30 -44 -3 -11 -8 -35 -12 -52 -7 -40 5 -42 54 -9
l36 25 39 -26 c50 -34 65 -22 47 36 -12 41 -12 41 27 75 43 38 39 43 -30 48
-37 3 -40 6 -54 46 -14 44 -35 54 -50 25z m60 -103 c20 0 20 -1 3 -20 -9 -10
-15 -25 -12 -33 4 -10 -4 -13 -29 -13 -26 1 -34 5 -34 20 0 10 -8 25 -17 32
-16 12 -16 13 8 14 16 0 30 7 34 18 6 16 7 16 16 0 6 -10 19 -18 31 -18z"
      />
      <path
        d="M610 1098 c-15 -42 -16 -43 -62 -46 -58 -4 -62 -19 -13 -56 l34 -26
-14 -41 c-23 -65 -6 -76 51 -33 l34 26 34 -26 c57 -43 74 -32 51 33 l-14 41
34 26 c49 37 45 52 -12 56 -47 3 -48 4 -63 46 -9 25 -21 42 -30 42 -9 0 -21
-17 -30 -42z m40 -63 c0 -10 10 -15 27 -15 25 0 25 -1 9 -19 -12 -13 -15 -27
-11 -41 6 -19 5 -20 -14 -8 -17 10 -25 10 -42 0 -19 -12 -20 -11 -14 8 4 14 1
28 -11 41 -16 18 -16 19 9 19 17 0 27 5 27 15 0 8 5 15 10 15 6 0 10 -7 10
-15z"
      />
      <path
        d="M928 1098 c-14 -40 -17 -43 -54 -46 -69 -5 -73 -10 -30 -48 39 -34
39 -34 27 -75 -18 -58 -3 -70 47 -36 l39 26 36 -25 c49 -33 61 -31 54 9 -4 17
-9 41 -12 52 -4 15 3 26 30 44 51 34 46 51 -14 51 -49 0 -49 0 -63 42 -18 59
-42 61 -60 6z m73 -78 c22 -1 23 -2 7 -14 -10 -7 -18 -22 -18 -32 0 -15 -8
-19 -34 -20 -25 0 -33 3 -29 13 3 8 -3 23 -12 33 -17 19 -17 20 4 20 12 0 24
7 28 16 6 16 7 16 18 0 7 -9 23 -16 36 -16z"
      />
      <path
        d="M252 463 c3 -15 14 -18 63 -18 49 0 60 3 63 18 3 15 -5 17 -63 17
-58 0 -66 -2 -63 -17z"
      />
      <path
        d="M252 343 c3 -15 14 -18 63 -18 49 0 60 3 63 18 3 15 -5 17 -63 17
-58 0 -66 -2 -63 -17z"
      />
      <path
        d="M250 245 c0 -12 14 -15 65 -15 51 0 65 3 65 15 0 12 -14 15 -65 15
-51 0 -65 -3 -65 -15z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconSatisfacaoDoCidadao',
}
</script>

<style></style>
